module.exports = {
          srcSet: __webpack_public_path__ + "cf78b1041cceb29a3717d6bc1c44e130-37.png"+" 37w",
          images:[ {path: __webpack_public_path__ + "cf78b1041cceb29a3717d6bc1c44e130-37.png",width: 37,height: 37}],
          src: __webpack_public_path__ + "cf78b1041cceb29a3717d6bc1c44e130-37.png",
          toString:function(){return __webpack_public_path__ + "cf78b1041cceb29a3717d6bc1c44e130-37.png"},
          
          width: 37,
          height: 37
        }